module.exports = __webpack_public_path__ + "img/hyundai.9fb1c412.png";